module.exports = __webpack_public_path__ + "static/img/orderremark2.085b83d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/orderremark2.png
// module id = 1253
// module chunks = 0